<template>
  <div class="sidebar-container">
    <div class="logo-container">
      <a href="#/">
        <i class="iconfont icon-shuidi logo"></i>
        <div class="logo-text"></div>
      </a>
    </div>

    <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu
        mode="vertical"
        :show-timeout="200"
        background-color="#1F2B35"
        text-color="#fff"
        unique-opened
        collapse-transition
        router
        :default-active="activeMenu"
      >
        <template v-for="item in navList">
          <el-menu-item :index="item.path" v-if="!item.children.length > 0" :key="item.path">
            <i :class="'iconfont ' + item.icon"></i>
            <span slot="title">{{item.name}}</span>
          </el-menu-item>

          <el-submenu v-else :index="item.path" :key="item.path">
            <template slot="title">
              <i :class="'iconfont ' + item.icon"></i>
              <span slot="title">{{item.name}}</span>
            </template>

            <el-menu-item
              v-for="child in item.children"
              :key="item.path + child.path"
              :index="item.path + child.path"
            >{{child.name}}</el-menu-item>
          </el-submenu>
        </template>
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
export default {
  name: "SideBar",

  data() {
    return {};
  },

  computed: {
    activeMenu() {
      return this.$route.path;
    },

    navList() {
      return localStorage.navList ? JSON.parse(localStorage.navList) : [];
    }
  }
};
</script>

<style lang="scss">
@import url("//at.alicdn.com/t/font_1159734_3mdx3fefv5w.css");

.sidebar-container {
  width: 220px;
  color: #fff;
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  background-color: #1f2b35;
  overflow: hidden;

  .logo-container {
    height: 70px;

    padding: 0 20px;

    a {
      display: inline-block;
      width: 100%;
      color: #fff;
    }

    .logo {
      font-size: 28px;
      vertical-align: middle;
      margin-right: 10px;
    }

    .logo-text {
      font-size: 16px;

      display: inline-block;
      height: 70px;
      line-height: 70px;
    }
  }

  .el-scrollbar {
    height: calc(100% - 70px);
  }

  .scrollbar-wrapper {
    height: 100%;
  }

  .el-menu {
    height: 100%;
    border: none;

    .iconfont {
      margin-right: 10px;
    }

    .el-menu-item,
    .el-submenu__title {
      height: 45px;
      line-height: 45px;
      border-left: 5px solid transparent;
    }

    .el-submenu.is-active.is-opened {
      .el-submenu__title {
        border-left: 5px solid #409eff !important;
      }
    }

    // .el-menu-item.is-active {
    //   border-left: 5px solid #409eff !important;
    // }
  }
}
</style>
